import SkeletonLoader from '@/components/SkeletonLoader';

const DeviceDetailsSkeleton = () => {
  return (
    <div className="w-full bg-white space-y-10 p-0.5">
      {/* Device Header Card */}
      <div className="bg-brand-light-50 rounded-2xl p-6 space-y-6">
        <div className="flex gap-2 items-center">
          <div className="flex-1 flex items-center justify-between">
            <div className="flex gap-2 items-center">
              <SkeletonLoader className="h-8 w-8 rounded-lg" variant="rect" />
              <SkeletonLoader className="h-6 w-32" variant="text" />
            </div>
            <SkeletonLoader className="h-8 w-40 rounded" variant="rect" />
          </div>
        </div>

        {/* Rows in Card */}
        <div className="space-y-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex justify-between items-center text-sm">
              <SkeletonLoader className="h-4 w-32" variant="text" />
              <SkeletonLoader className="h-4 w-20" variant="text" />
            </div>
          ))}
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-y-6 gap-x-12">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="flex items-start gap-3">
            <div className="mt-0.5">
              <SkeletonLoader className="h-5 w-5 rounded" variant="rect" />
            </div>
            <div className="flex flex-col gap-1">
              <SkeletonLoader className="h-4 w-24" variant="text" />
              <SkeletonLoader className="h-4 w-12" variant="text" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DeviceDetailsSkeleton;
